(function($){

    // show/hide group blocks based on the region selected from dropdown
    // hide all blocks not set to active
    $('.region-block:not(.active)').hide();

    $('.select-region select').on( 'change', function() {
        // get data-block value from selected li
        var selectedBlock = this.value;

        // slide the region open and close the previous one
        $('.region-block.active').slideUp().removeClass('active');
        $('.regions').find('#' +selectedBlock).addClass('active').slideDown();
    })
})(jQuery);